import axiosApiClient from "../axios";

const PATH = '/api/admin';

export const getAllAdmins = async () => {
    try {
        return await axiosApiClient.get(PATH);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to get all admins');
    }
};

export const getAdminById = async (id) => {
    try {
        return await axiosApiClient.get(`${PATH}/${id}`);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to get admin by ID');
    }
};

export const getAdminByUsername = async (username) => {
    try {
        return await axiosApiClient.get(`${PATH}/username/${username}`);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to get admin by username');
    }
};

export const createAdmin = async (formData) => {
    try {
        return await axiosApiClient.post(PATH, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to create admin');
    }
};

export const updateAdmin = async (id, formData) => {
    try {
        return await axiosApiClient.put(`${PATH}/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to update admin');
    }
};

export const deleteAdmin = async (id) => {
    try {
        return await axiosApiClient.delete(`${PATH}/${id}`);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to delete admin');
    }
};
